<template>
  <div class="score-panel">
    <b-list-group>
      <b-list-group-item v-if="headline !== ''" class="score-headline">{{
        headline
      }}</b-list-group-item>
      <b-list-group-item v-if="scores.length === 0" class="score-list-item">
        <div class="score-list-item-left">
          <div v-text="$ml.get('platzhalter')"></div>
        </div>
      </b-list-group-item>
      <b-list-group-item
        v-for="(score, index) in scores"
        :key="score.user + score.score + index"
        :class="{
          active: score.user,
          'score-fade': score.fade,
          'score-shadow': scores[index - 1] ? scores[index - 1].fade : false,
        }"
        class="score-list-item"
      >
        <div class="score-list-item-left">
          <div class="score-position">{{ score.position }}</div>
          <div>{{ score.user_name }}</div>
        </div>
        <div>{{ score.score }}</div>
      </b-list-group-item>
    </b-list-group>
  </div>
</template>

<script>
export default {
  name: "ScorePanel",
  props: {
    headline: { type: String, default: "" },
    scores: { type: Array, default: () => [] },
  },
  methods: {},
};
</script>

<style scoped>
.score-panel {
  color: #0178b7;
  max-width: 300px;
}
.score-headline {
  font-size: 1.2rem;
  font-weight: bold;
}

.score-list-item {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.score-list-item-left {
  display: flex;
  flex-direction: row;
}

.score-position {
  padding-left: 10px;
  padding-right: 20px;
}

.score-fade {
  color: rgba(1, 120, 183, 0.3);
  margin-bottom: -10px;
}

.score-shadow {
  box-shadow: 0px -12px 20px -15px rgba(0, 0, 0, 0.75);
}
</style>
